import cloneObject from "@/libs/cloneObject";
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import TranslationForm from "@/components/Includes/TranslationForm/TranslationForm.vue";
import IMeditationResource from "@/interfaces/astrology/meditation/meditationResource/IMeditationResource";
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import {Switch as cSwitch} from '@coreui/vue';
import Multiselect from 'vue-multiselect';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
    name: 'MeditationRecourceForm',
    components: {
        Multiselect,
        TranslationForm,
        cSwitch
    }
})
export default class MeditationRecourceForm extends Vue {
    @Prop(Object) private formData!: IMeditationResource;
    @Prop(Array) private meditationCategories!: IMultiSelectItem[];
    @Prop(Boolean) private loading!: boolean;

    // Begin Handler by Form
    private checkRequired(field: string): string {
        const requiredFields = [
            'category',
            'name',
            'thumbnail',
            'background',
            'sound',
            'premium',
            'active'
        ];

        const intField: boolean = field === 'value';

        return intField ? 'required|numeric' : (requiredFields.indexOf(field) !== -1 ? 'required' : 'min:1');
    }

    private invalidValue(fieldName: string) {
        return this.$validator.errors.has(fieldName);
    }

    private transformData() {
        const readyData = cloneObject(this.formData);
        readyData.category = readyData.category.value;
        delete readyData.createdAt;
        delete readyData.updatedAt;
        return readyData;
    }


    private validateForm() {
        this.$validator.validateAll().then((result) => {
            if (result) {
                this.$emit('saveForm', this.transformData());
            }
        });
    }

    private handleSave() {
        this.validateForm();
    }

    private transformLabel(field: string): string {
        return capitalizeFirstLetter(field);
    }

    private hideFields(field: string): boolean {
        const fields = [
            'id',
            'createdAt',
            'updatedAt'
        ];

        return fields.includes(field);
    }
    // End Handler by Form
}
